import { dbApi, getApiErrorMessage } from "@/lib/api"

export type MessageFeedback = "up" | "down"

export async function submitChatFeedback(
  chatId: string,
  feedback: MessageFeedback,
  timestamp?: string
): Promise<{ ok: true } | { ok: false; error: string }> {
  try {
    await dbApi.post(`/api/chat/${encodeURIComponent(chatId)}/feedback`, {
      feedback,
      ...(timestamp ? { timestamp } : {}),
    })
    return { ok: true }
  } catch (e) {
    return { ok: false, error: getApiErrorMessage(e) }
  }
}
